import { Alert as ChakraAlert, AlertTitle, HStack } from '@chakra-ui/react';
import { IconButton } from 'Atoms/Buttons';
import { Typography } from 'Tokens';
import React, { useState } from 'react';
import { InfoIcon } from 'Tokens/Icons/Status';
import { RemoveIcon } from 'Tokens/Icons/Function';
import { Link } from 'Atoms/index.ts';

export const NonMaterialityInfoBox = () => {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <ChakraAlert display="flex" colorScheme={'info'} status="info">
      <HStack justifyContent="space-between" flexGrow={1}>
        <HStack spacing="8px">
          <InfoIcon color="text.info" />;
          <AlertTitle>
            <Typography variant="detail">
              Taxonomy-non-material or non-eligible activities now in the financials page. Learn
              more about{' '}
              <Link href="#" textColor="text.info">
                materiality
              </Link>
              .
            </Typography>
          </AlertTitle>
        </HStack>
        <IconButton
          variant="ghost"
          aria-label="CloseButton"
          size="sm"
          icon={<RemoveIcon color="inherit" />}
          onClick={() => setVisible(false)}
        />
      </HStack>
    </ChakraAlert>
  );
};
